export const getPriorityLegend = (priority: number): string => {
  if (priority === 0) {
    return $localize`Ninguna`;
  } else if (priority === 1) {
    return $localize`Baja`;
  } else if (priority === 5) {
    return $localize`Media`;
  } else if (priority === 9) {
    return $localize`Alta`;
  }
  return '';
};
